<div class="fs-2 mb-2 text-primary">
  Doplňující informace
</div>

<div class="mb-2">
  Informace které pomohou blíže specifikovat Vaše požadavky
</div>

<div class="border p-3 mb-4">

  <div *ngIf="calculation">
    <div class="fw-bold mb-4">
      Identifikátor kalkulace: {{calculation.id}}
    </div>
  </div>

  <form [formGroup]="customerForm">

    <label for="note" class="form-label">Poznámka</label>
    <input id="note" class="form-control mb-4" [formControlName]="'note'" placeholder="Vaše poznámka" type="string">

  </form>

  <input class="form-control mb-4" type="file" (change)="onFileSelected($event)" #fileInput>

</div>

<div class="d-grid">
  <button class="btn btn-lg w-full rounded-pill btn-primary btn-block" (click)="onSubmit()">Odeslat</button>
</div>
